import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import { api, type Me } from '../api/client';

/** 目前登入者（null = 未登入）。 */
export function useMe() {
  return useQuery<Me | null>({ queryKey: ['me'], queryFn: api.me, retry: false });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.logout,
    onSuccess: () => qc.setQueryData(['me'], null),
  });
}

export function can(me: Me | null | undefined, permission: string): boolean {
  return !!me?.permissions.includes(permission);
}
